import { Tooltip } from "components/components/tooltip/tooltip";
import { Option } from "components/input/select/options";
import optionsTemplate from "components/input/select/options.hbs";
import { DoubleListLeftSideElement } from "./doubleListLeftSideElement";
import { FocusManager } from "components/pages/focusManager";
import { Message } from "components/actions/response";
import * as message from "components/message/message";
import template from "./doubleListElement.hbs";
import "./doubleListElement.scss";

export class DoubleListSelectElement extends HTMLElement {

  private _data: Set<string | number> = new Set();
  private _options: Option[];

  private visited = false;
  private oldValue: Array<string | number>;
  private _valid: boolean;

  private toRightButton: HTMLButtonElement;
  private toLeftButton: HTMLButtonElement;
  private allToLeftButton: HTMLButtonElement;
  private allToRightButton: HTMLButtonElement;
  private rightSelect: HTMLSelectElement;
  private leftSelect: DoubleListLeftSideElement;

  private tabOnEnter: boolean;
  private maxSelectable: number;
  private msgWarning: Message;
  private _optionsInputFilter: OptionsInputFilter;

  constructor() {
    super();

    this.innerHTML = template({});

    if (this.hasAttribute("leftSideList")) {
      this.querySelector(".leftside").append(this.getLeftList());
    }
    this.toRightButton = this.querySelector(".toRight");
    this.toLeftButton = this.querySelector(".toLeft");
    this.allToRightButton = this.querySelector(".allToRight");
    this.allToLeftButton = this.querySelector(".allToLeft");
    this.rightSelect = this.querySelector(".rightside select");
    this.leftSelect = this.querySelector("s6-double-list-left-side");

    this.tabOnEnter = this.hasAttribute("tabOnEnter");
    this.maxSelectable = parseInt(this.getAttribute("maxSelectable") ?? "1000", 10);
    this.msgWarning = { level: "warn", key: "doublelist.max_selection", args: [this.maxSelectable] };
    this._optionsInputFilter = {
      minNumsCharsToFilter: parseInt(this.getAttribute("minNumsCharsToFilter") ?? "0", 10),
      caseSensitive: this.hasAttribute("caseSensitive"),
      useWildcars: this.hasAttribute("useWildcars"),
    };
    if (this._optionsInputFilter.useWildcars) {
      this._optionsInputFilter.wildcardGroupChars = this.getAttribute("wildcardGroupChars");
      this._optionsInputFilter.wildcardChar = this.getAttribute("wildcardChar");
    }

    Tooltip.bindElement(this);
    this.bindEvents();
  }

  private bindEvents() {

    this.addEventListener("focusin", () => {
      this.visited = true;
    });

    this.allToRightButton.addEventListener("click", this.moveAllToRight);
    this.addEventTabOnEnter(this.allToRightButton);
    this.allToLeftButton.addEventListener("click", () => {
      this._data = new Set();
      if (this.rightSelect.options.length === 0) {
        return;
      }
      this.fireDataChanged();
      this.render();
    });
    this.addEventTabOnEnter(this.allToLeftButton);

    this.toRightButton.addEventListener("click", this.moveToRight);
    this.addEventTabOnEnter(this.toRightButton);

    this.toLeftButton.addEventListener("click", this.moveToLeft);
    this.addEventTabOnEnter(this.toLeftButton);

    this.rightSelect.addEventListener("change", (evt) => evt.stopPropagation());
    this.rightSelect.addEventListener("dblclick", this.moveToLeft);
    this.addEventTabOnEnter(this.rightSelect);

  }

  private addEventTabOnEnter(element: HTMLElement) {
    if (this.tabOnEnter === true) {
      element.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.stopPropagation();
          e.preventDefault();
          FocusManager.focusNext();
        }
      });
    }
  }

  private moveAllToRight = () => {
    const righSideFull =
      this.rightSelect.options.length >= this.maxSelectable;
    if (this.leftSelect.options.length === 0 || righSideFull) {
      if (righSideFull && this.leftSelect.options.length !== 0) {
        message.show(this.msgWarning);
      }
      return;
    }

    var allOptions = this.options;
    if (this.leftSelect.isFiltering()) {
      //Options filtradas
      var leftFilterOptions = this.leftSelect.filterOptions;
      //Options que ya estaban añadidas
      var rightOptions = Array.apply(null, this.rightSelect.options);

      this._data = new Set(allOptions.slice(0, this.maxSelectable).filter((el) => {
        return (rightOptions.some((f) => { return f.value === el.value }) || leftFilterOptions.some((f) => { return f.value === el.value }));
      }).map((v) => v.value));
    } else {
      this._data = new Set(allOptions.slice(0, this.maxSelectable).map((v) => v.value));
      if (this.leftSelect.options.length >= this.maxSelectable) {
        message.show(this.msgWarning);
      }
    }

    this.fireDataChanged();
    this.render();
  }

  public moveToRight = () => {
    const righSideFull =
      this.rightSelect.options.length >= this.maxSelectable;
    const selected = Array.from(this.leftSelect.selectedOptions);
    if (selected == null || righSideFull) {
      message.show(this.msgWarning);
      return;
    }
    const slice = this.maxSelectable - this.rightSelect.options.length;
    Array.from(selected.slice(0, slice)).forEach((v) => this._data.add(v.value));
    this.fireDataChanged();
    this.render();
  }

  private moveToLeft = () => {
    const selected = this.rightSelect.selectedOptions;
    if (selected == null) {
      return;
    }
    const stringList = [...this._data].map((o) => o.toString());

    Array.from(selected).forEach((v) => {
      if (this._data.has(v.value)) {
        this._data.delete(v.value);
      }
      if (stringList.includes(v.value)) {
        this._data.delete(parseInt(v.value, 10));
      }
    });
    this.fireDataChanged();
    this.render();
  }

  private fireDataChanged() {
    this.dispatchEvent(new CustomEvent("change", { bubbles: true }));
  }

  private getLeftList() {
    const t = document.createElement("template");
    let strHTML = "<s6-double-list-left-side";
    if (this.hasAttribute("codeInOptionLabel")) {
      strHTML += " codeInOptionLabel ";
    }
    if (this.hasAttribute("tabOnEnter")) {
      strHTML += " tabOnEnter ";
    }
    strHTML += "></s6-double-list-left-side>";
    t.innerHTML = strHTML;

    return t.content.firstChild;
  }

  public focus(): void {
    // this.input.focus();
  }

  public set readOnly(ro: boolean) {
    this.allToLeftButton.disabled = ro;
    this.allToRightButton.disabled = ro;
    this.toRightButton.disabled = ro;
    this.toLeftButton.disabled = ro;
    this.rightSelect.disabled = ro;
    if (this.leftSelect != null) {
      this.leftSelect.disabled = ro;
    }
  }

  public set valid(valid: boolean) {
    this._valid = valid ?? true;
    if (this._valid) {
      this.rightSelect.classList.remove("has-error");
      this.rightSelect.classList.remove("is-pending");
      this.removeAttribute("data-tip");
    } else {
      if (this.visited) {
        this.rightSelect.classList.add("has-error");
        this.rightSelect.classList.remove("is-pending");
      } else {
        this.rightSelect.classList.add("is-pending");
      }
    }
  }

  public set validationMessage(message) {
    if (message != null) {
      this.setAttribute("data-tip", message);
    }
  }

  public set data(data: Array<string | number>) {
    this.oldValue = { ...data };
    this._data = new Set(data);
    this.render();
  }

  public get data(): Array<string | number> {
    let data = Array.from(this._data);
    if (this._data.size === 0) {
      data = null;
    }
    return data;
  }

  public set options(options) {
    this._options = options;
    this.render();
  }

  public get options() {
    return this._options;
  }

  public get optionsInputFilter(): OptionsInputFilter {
    return this._optionsInputFilter;
  }

  private render() {
    if (this.hasAttribute("leftSideList")) {
      this.renderLeftSideOptions();
    }
    this.renderRightSideOptions();
  }

  private renderLeftSideOptions() {
    const t = document.createElement("template");
    t.innerHTML = "<select multiple></select>";
    const options = [];
    this._data = this._data ?? new Set();
    const stringList = [...this._data].map((o) => o.toString());
    for (const option of this._options ?? []) {
      if (!stringList.includes(option.value?.toString())) {
        options.push(option);
      }
    }
    this.leftSelect.doubleListSelect = this;
    this.leftSelect.options = options;
  }

  private renderRightSideOptions() {
    const t = document.createElement("template");
    t.innerHTML = "<select multiple></select>";
    this.querySelector(".rightside select").innerHTML = "";
    const rightSideOptions = [];
    this._data = this._data ?? new Set();
    const stringList = [...this._data].map((o) => o.toString());
    for (const option of this._options ?? []) {
      if (stringList.includes(option.value?.toString())) {
        rightSideOptions.push(option);
      }
    }

    this.rightSelect.innerHTML = "";
    this.rightSelect.innerHTML = optionsTemplate({
      options: rightSideOptions,
      codeInOptionLabel: this.hasAttribute("codeInOptionLabel"),
    });
  }
}

export interface OptionsInputFilter {
  caseSensitive?: boolean;
  minNumsCharsToFilter?: number;
  useWildcars?: boolean;
  wildcardGroupChars?: string
  wildcardChar?: string
}

export function initDoubleListInputWebComponent(): void {
  window.customElements.define("s6-double-list-input", DoubleListSelectElement);
}
